import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { LocaleProvider } from 'antd';
import lodash from 'lodash';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import Loading from 'components/RouteLoading';
import renderRoutes from 'libs/routes';
import createContext from 'libs/context';
import http from 'libs/http';
import './index.less';
import '../mock'
moment.locale('zh-cn');

const { Provider } = createContext('authority', {});
class Root extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      initData: {
        authority: {},
        menuList: [],
        siteList: [],
        userName: '',
        siteName: '',
        siteId: '',
        notice: {}
      }
    };
  }

  componentDidMount() {
    this.initData();
  }
  
  //数据初始化
  initData = () => {
    let promistList = [];
    if (window.location.href.includes('/login')) {
      promistList = []
    } else {
      promistList = [
        http.get('/sys/menu/init'),
        http.json('/sys/menu/top'),
        http.get('/sys/notice/top')
      ];
    }
    Promise.all(promistList).then(res => {
      const authority = {};
      const siteList = lodash.get(res, '[0].siteList', []);
      const menuList = lodash.get(res, '[0].menuList', []);
      const functionList = lodash.get(res, '[0].functionList', []);
      const userName = lodash.get(res, '[1].userName', '');
      const siteName = lodash.get(res, '[1].siteName', '');
      const notice = lodash.get(res, '[2].notice', '');
      let siteId = '';
      functionList.forEach(item => authority[item] = true);
      siteList.forEach(item => {
        if (item.name === siteName) {
          siteId = item.id;
        }
      });
      this.setState({
        loading: false,
        initData: { authority, menuList, siteList, userName, siteName, siteId, notice }
      });
      window.localStorage.setItem('authority', JSON.stringify(authority))
    }).catch(() => this.setState({ loading: false }));
  }

  render() {
    const { loading, initData  } = this.state;
    if (loading) return <Loading />;
    return (
      <LocaleProvider locale={zhCN}>
        <Router>
          <Provider value={{ ...initData }}>
            {renderRoutes('/', initData.authority)}
          </Provider>
        </Router>
      </LocaleProvider>
    );
  }
}

export default Root;
